(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["custom-read-more"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.read-more-btn').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      const container = btn.closest('.read-more-container');
      const minimized = container.querySelector('.text.minimized');
      const full = container.querySelector('.text.full');
      const isExpanded = full.style.display === 'block';

      minimized.style.display = isExpanded ? 'block' : 'none';
      full.style.display = isExpanded ? 'none' : 'block';
      btn.classList.toggle('expanded', !isExpanded);
    });
  });
});
  } catch(e) { console.error(e); }
})();

})();
